import * as BlackCard from 'root/src/client/v2/common/components/BlackCard/BlackCard';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { memo } from 'react';
export const DropsListItemPlaceholder = memo(() => {
    return (<li>
			<BlackCard.Root>
				<BlackCard.Header className="h-[30%] bg-gradient-to-tr from-bg-dark-1 to-bg-dark-3">
					<LoadingCircles width={50} height={50} key={0}/>
				</BlackCard.Header>
				<BlackCard.Separator className="flex flex-initial h-8 justify-around px-2 py-0.5 gap-2 items-center">
					<div className="flex relative items-center">
						<span className="flex flex-initial self-left justify-center items-center font-bold text-lg bg-primary w-12 h-12 rounded-full shadow-[0_0_10px_2px_#00FFED] drop-shadow-[0_0_8px_#00FFED] border-2 border-white">
							?
						</span>
					</div>
					<span className="flex flex-initial w-full text-xs p-1 blur-sm">Awesome brand</span>
				</BlackCard.Separator>
				<BlackCard.Body className="p-6 gap-2">
					<div className="animate-skeleton-loading bg-dark-2 w-3/4 h-2 rounded py-3 my-2"/>
					<div className="flex flex-col justify-start items-start gap-2">
						<div className="animate-skeleton-loading bg-dark-2 w-full h-2 rounded py-2"/>
						<div className="animate-skeleton-loading bg-dark-2 w-3/4 h-2 rounded py-2"/>
						<div className="animate-skeleton-loading bg-dark-2 w-1/2 h-2 rounded py-2"/>
					</div>
				</BlackCard.Body>
				<BlackCard.Footer>
					<div className="animate-skeleton-loading bg-dark-2 w-1/2 h-2 rounded py-4"/>
				</BlackCard.Footer>
			</BlackCard.Root>
		</li>);
});
